export default __webpack_public_path__ + "static/media/Average_Difficulty_vs_Number_of_Instructors_Without_0.4e773f8f.png";